import axios from "axios";

const getCookie = (name) => {
  if (typeof document !== "undefined") {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
  }
  return null;
};

export const Axios = axios.create({
  baseURL: "https://api.marvellife.co/api/v2",
  headers: {
    "Content-Type": "application/json",
  },
});

Axios.interceptors.request.use(
  (config) => {
    const token = getCookie("token");
    if (token) {
      config.headers["x-auth-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default Axios;
